import React, { useContext } from "react";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { formatAddress } from "../../funcitons";

export default function Account() {
  const { account, superelite, elite, disconnectNow, settings } =
    useContext(ProjectContext);
  var navigate = useNavigate();

  const logout = () => {
    disconnectNow();
    navigate("/");
  };

  return (
    <>
      <section className="profile__area pt-200 pb-120 bg-black">
        <div className="container">
          <div className="profile__inner p-relative">
            <div className="row">
              <div className="col-xxl-12 col-lg-8">
                <div
                  className="profile__tab-content box-profile bg-black"
                  style={{
                    backgroundPosition: "50% 50%",
                    backgroundSize: "cover",
                    backgroundImage: "url(assets/img/one/profile_hero_bg.png)",
                  }}
                >
                  <div className="tab-content" id="profile-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                    >
                      <div className="profile__main">
                        <div className="profile__main-top pb-80">
                          <div className="row align-items-center">
                            <div className="col-md-6">
                              <div className="profile__main-inner d-flex flex-wrap align-items-center">
                                <div className="profile__main-thumb">
                                  {/* <img src="assets/img/one/user.png" alt="" /> */}
                                  <img src="favicon.png" alt="" />
                                </div>
                                <div className="profile__main-content">
                                  <h5 className="profile__main-title">
                                    Welcome to Kryptogram
                                  </h5>
                                  <h6 className="pt-5">
                                    {formatAddress(account)}
                                  </h6>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-md-6">
                              <div className="profile__main-logout text-sm-end">
                                <a
                                  href="#"
                                  className="tp-logout-btn"
                                  onClick={logout}
                                >
                                  Disconnect
                                </a>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div className="profile__main-info">
                          <div className="row gx-3">
                            <h3>Elite ({elite.nfts.length})</h3>
                            {elite.nfts.map((nft, index) => (
                              <div className="col-md-3 col-sm-6 p-1">
                                <div className="profile__main-info-item box-profile-one bg-black">
                                  <div className="profile__main-info-icon">
                                    <span>
                                      <video
                                        muted
                                        autoPlay
                                        loop
                                        id="myVideo"
                                        className="video w-100"
                                      >
                                        <source
                                          src={elite.url}
                                          type="video/mp4"
                                        />
                                      </video>
                                    </span>
                                  </div>
                                  <a
                                    href={`${process.env.REACT_APP_EXPLORER}token/${settings.eliteAddress}?a=${nft}`}
                                    className="profile__main-info-title"
                                    target="_blank"
                                  >
                                    # {nft}
                                  </a>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="row gx-3 pt-4">
                            <h3 className="text-yellow-new">
                              Super Elite ({superelite.nfts.length})
                            </h3>
                            {superelite.nfts.map((nft, index) => (
                              <div className="col-md-3 col-sm-6 p-1">
                                <div className="profile__main-info-item box-profile-one bg-black">
                                  <div className="profile__main-info-icon">
                                    <span>
                                      <video
                                        muted
                                        autoPlay
                                        loop
                                        id="myVideo"
                                        className="video w-100"
                                      >
                                        <source
                                          src={superelite.url}
                                          type="video/mp4"
                                        />
                                      </video>
                                    </span>
                                  </div>
                                  <a
                                    href={`${process.env.REACT_APP_EXPLORER}token/${settings.sEliteAddress}?a=${nft}`}
                                    className="profile__main-info-title"
                                    target="_blank"
                                  >
                                    # {nft}
                                  </a>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
